
import { defineComponent } from "vue";
import Report from "./Report.vue";
import LoadingReportFilter from "./LoadingReportFilter.vue";
import router from "@/router";
import { ReportType } from "./ReportType";
import LoadingReportInfoDialog from "@/components/info/LoadingReportInfoDialog.vue";

export default defineComponent({
  components: {
    Report,
    LoadingReportFilter,
    LoadingReportInfoDialog,
  },
  computed: {
    reportType(): any {
      return ReportType.LoadingReport;
    },
  },
  methods: {
    onReport(planId: any, options: any) {
      this.$refs.reportComponent.onReport(planId, options);
    },
    onDownload(planId: any, options: any) {
      this.$refs.reportComponent.onDownload(planId, options);
    },
    onStop() {
      this.$refs.reportComponent.onStop();
    },
  },
  mounted() {
    const routeParams = router.currentRoute.value.params;
    if (routeParams.planId) {
      const model = {
        planId: parseInt(routeParams.planId as string),
        planDescription: routeParams.planDescription,
      };
      this.$refs.reportFilter.setModel(model);
    }
  },
});
